import { useEffect, useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

let open = null;
export const CANCELLED = "budget-cancelled";

const askBudget = (detail) => new Promise((resolve) => (open ? open(detail, resolve) : resolve(false)));

// Runs fn(confirm=false); if the server says it would go over the monthly AI limit, asks first, then re-runs with confirm=true.
export async function withBudget(fn) {
  try {
    return await fn(false);
  } catch (e) {
    const d = e?.response?.data?.detail;
    if (e?.response?.status !== 409 || d?.code !== "over_budget") throw e;
    if (await askBudget(d)) return fn(true);
    throw new Error(CANCELLED);
  }
}

export const BudgetConfirmHost = () => {
  const [state, setState] = useState(null);
  useEffect(() => {
    open = (detail, resolve) => setState({ detail, resolve });
    return () => { open = null; };
  }, []);
  const close = (ok) => { state?.resolve(ok); setState(null); };
  const d = state?.detail;
  return (
    <AlertDialog open={!!state} onOpenChange={(o) => { if (!o) close(false); }}>
      <AlertDialogContent data-testid="budget-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>This goes over your monthly AI limit</AlertDialogTitle>
          <AlertDialogDescription>
            {d && <>This will use about <b>{d.estimate}</b> credits. You've used about <b>{d.used}</b> of your <b>{d.limit}</b> credit limit this month, so you'd end at about <b>{Math.round((d.used + d.estimate) * 100) / 100}</b>.</>}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => close(false)} data-testid="budget-confirm-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => close(true)} data-testid="budget-confirm-continue">Go over the limit anyway</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
